module.exports = __webpack_public_path__ + "static/scale-model-of-abq-biopark-aquarium-in-albuquerque-new-mexico-d49495ef7ef9313cc9ed7ee7a4f170d3.png";